import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

interface DataNode {
  name: string;
  children?: DataNode[];
  value?: number;
}

@Component({
  selector: "app-nav-tree",
  templateUrl: "./nav-tree.component.html",
  standalone: false,
  styles: [
    `
      .nav-tree-container {
        font-family: inherit;
      }
      .nav-tree-summary {
        display: flex;
        gap: 24px;
        padding: 16px 20px;
        background: #f8faff;
        border-bottom: 1px solid #e5e7eb;
      }
      .nav-tree-stat {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 80px;
      }
      .nav-tree-stat-value {
        font-size: 22px;
        font-weight: 700;
        color: #1e293b;
        line-height: 1;
      }
      .nav-tree-stat-label {
        font-size: 11px;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-top: 4px;
      }
      .nav-tree-header {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        background: #f1f5f9;
        border-bottom: 2px solid #e2e8f0;
        gap: 8px;
      }
      .nav-tree-col-toggle {
        width: 18px;
        flex-shrink: 0;
      }
      .nav-tree-col-name {
        flex: 1;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #64748b;
        min-width: 0;
      }
      .nav-tree-col-visits {
        width: 52px;
        text-align: right;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #64748b;
        flex-shrink: 0;
      }
      .nav-tree-col-bar {
        width: 120px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #64748b;
        flex-shrink: 0;
      }
      .nav-tree-body {
        max-height: 480px;
        overflow-y: auto;
      }
      .nav-tree-empty {
        text-align: center;
        padding: 48px;
        color: #94a3b8;
      }
    `,
  ],
})
export class NavTreeComponent implements OnChanges {
  @Input() data: DataNode | null = null;

  roots: DataNode[] = [];
  maxVisits: number = 1;
  totalVisits: number = 0;
  totalCategories: number = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["data"]) {
      this.buildTree();
    }
  }

  private buildTree() {
    if (!this.data || !this.data.children) {
      this.roots = [];
      this.maxVisits = 1;
      this.totalVisits = 0;
      this.totalCategories = 0;
      return;
    }
    this.roots = this.data.children;
    const visitCounts = this.roots.map((n) => this.sumVisits(n));
    this.maxVisits = Math.max(...visitCounts, 1);
    this.totalVisits = visitCounts.reduce((a, b) => a + b, 0);
    this.totalCategories = this.roots.length;
  }

  private sumVisits(node: DataNode): number {
    if (!node) return 0;
    if (!node.children || !node.children.length) return node.value || 0;
    return node.children.reduce((acc, c) => acc + this.sumVisits(c), 0);
  }
}
